import { Table } from "best-common-react";
import React from "react";
import { getAllotmentByRequest } from "../../../api/RequesTixApi";
import { UserAllotmentCountDTO } from "../../../types/Allotment";
import { RequestTypeDesc } from "../../../types/RequestType";
import { capitalizeFirstLetter } from "../../../util/StringUtil";

type RequestAllotmentTableProps = {
  requestId: number;
  category?: RequestTypeDesc;
};

const RequestAllotmentTable: React.FC<RequestAllotmentTableProps> = ({ requestId, category }) => {
  const [allotment, setAllotment] = React.useState<UserAllotmentCountDTO>();

  const fetchAllotment = async (): Promise<void> => {
    try {
      const res: UserAllotmentCountDTO = await getAllotmentByRequest(requestId);
      setAllotment(res);
    } catch (e) {
      console.error(e);
    }
  };

  React.useEffect(() => {
    void fetchAllotment();
  }, [requestId]);

  return (
    <Table>
      <Table.Head>
        <Table.Row>
          <Table.Header>Req Totals</Table.Header>
          <Table.Header>Pending</Table.Header>
          <Table.Header>Approved</Table.Header>
          <Table.Header>Allotted</Table.Header>
        </Table.Row>
      </Table.Head>
      <Table.Body>
        <Table.Row>
          <Table.TdInfo>{capitalizeFirstLetter(category)}</Table.TdInfo>
          <Table.Td>{allotment?.pending}</Table.Td>
          <Table.Td>
            {allotment?.used} {allotment?.comped ? ` (${allotment?.comped} comp)` : ""}
          </Table.Td>
          <Table.Td>{allotment?.unlimited ? "unlimited" : allotment?.allowed}</Table.Td>
        </Table.Row>
      </Table.Body>
    </Table>
  );
};

export default RequestAllotmentTable;
